import type { PlatformEnv } from '@evc/platform';
import { ENVIRONMENT } from '@evc/platform';
import type { WebComponentsEnv } from '@evc/web-components';
import type { SharedEnv } from '@shared/services/config/config.type';

export { ENVIRONMENT } from '@evc/platform';

export type AppEnv = SharedEnv & PlatformEnv & WebComponentsEnv;

export const environment: AppEnv = {
  APP_NAME: 'Product Support',
  ENV: ENVIRONMENT.production,
  USE_CONNECT_PLATFORM: true,
};
